'use strict';

var user_login_model = require('./user_login.model.js');
var user_update_model = require('./user_update.model.js');
var page_view_model = require('./page_view.model.js');
var page_submit_model = require('./page_submit.model.js');
var page_abandon_model = require('./page_abandon.model.js');

var schemas = {
  user_login: user_login_model,
  user_update: user_update_model,
  page_view: page_view_model,
  page_submit: page_submit_model,
  page_abandon: page_abandon_model
};
var signupSchemas = schemas;

module.exports = signupSchemas;
//# sourceMappingURL=index.js.map
